import { useWeb3Modal } from '@web3modal/wagmi/react'
import { BuyToken } from '../../../../../../hooks/useWritePresale';
import toast from 'react-hot-toast';
import { InfoData } from '../../../../../../hooks/useApiCalls';
import { ReactSession } from 'react-client-session';
import { useAccount ,useBalance } from 'wagmi';

function ConnectButton(probs) {

    const connected = probs.isConnected;
    const { open } = useWeb3Modal();
    const amountETH = probs.amount;
    const PresaleAddr = InfoData();

    const refWall =  ReactSession.get("refwallet");

    const { address } = useAccount();

    const { data, isLoading, isError } = useBalance({
        address: address,
      });

    const balance = data ? data.formatted : 0;

     

    const getRefWalletAddress = (refWall) => {
        const contractAddress = PresaleAddr.presalecontract;  
    
        if (address === refWall || refWall === contractAddress) {
            return "0x0000000000000000000000000000000000000000";
        }
    
        return refWall;
    };

  
    const clickButton = () =>{
        if(!connected){
            open();
        }else{
           
            if(amountETH > 0 && balance > amountETH){
                probs.setLoading(true);

                BuyToken(amountETH,PresaleAddr.presalecontract,getRefWalletAddress(refWall)).then((e)=>{
             
                    if(e.status == "success"){

                        probs.setTx(e.transactionHash);
                        probs.setBuysuccess(true);
                        probs.setLoading(false);
                       
                    }else if(e.status == "error"){
                        probs.setLoading(false);
                        if(e.message.details){
                            toast.error(e.message.details);
                        }else{
                            toast.error(e.message.cause.data.args[0]);
                        }                          
                    }
               
                });

            }else{
                toast.error("Balance Error");
            }
            
            
        }

  
    }

    return ( 
       <>
         <button onClick={clickButton} className={!connected ? "btn btn-connect w-100 blinking-button":"btn btn-connect w-100 "} ><i className={!connected ? "fas fa-wallet" : "fas fa-money-bill"} /> {!connected ? "Connect wallet" : "Buy Token"}</button>
       </> 
 ); 

}

export default ConnectButton;